import React from 'react';

import ButtonRefresh from './ButtonRefresh';
import MenuNewPlaylist from './MenuNewPlaylist';
import IconNew from '../svg/IconNew';

//V2
function NewPlaylistMenu() {
  return (
    <div className={`menu-left-container`} >
      <div id={`ref-rp`} className={`flexRow align top-menu-container`}  >
        <MenuNewPlaylist defaultClassColor={`type-light`}>
          <IconNew color={'#C2C2C2'} className={`icon-new-playlist`} />
          <span className={`type-medium fz14 label-new-playlist`}>Create playlist</span>
        </MenuNewPlaylist>
        <ButtonRefresh />
      </div>
    </div>
  )
}

export default NewPlaylistMenu;
